import { Box } from "@mui/material"
import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput, PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"

interface SpecificProductFilterChipsProps {
  selectedProducts: string[]
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
  specificProducts?: PriceChangeFilterLookupItem[]
}

const SpecificProductFilterChips: React.FC<SpecificProductFilterChipsProps> = ({
  selectedProducts,
  onRemove,
  specificProducts,
}) => {
  const specificProductNames = useMemo(
    () => specificProducts?.filter((product) => selectedProducts.includes(product.id)),
    [selectedProducts, specificProducts]
  )

  return (
    <Box className='flex flex-wrap gap-3'>
      {specificProductNames?.map((specificProduct) => (
        <FilterChip
          key={`pricing.specific-product-filter-chips.product-${specificProduct.id}`}
          data-testid={`pricing.specific-product-filter-chips.product-${specificProduct.id}`}
          label={`Specific Product: ${specificProduct.label}`}
          onDelete={() => onRemove("specificProductIds", specificProduct.id)}
        />
      ))}
    </Box>
  )
}

export default SpecificProductFilterChips
